import React from 'react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import Button, { fillClass } from './button';
import { cn } from '../../utils/cn';

const WINDOW = 5; // page numbers shown at once

// First page number to show, keeping the current page centred when possible
const windowStart = (page, totalPages) => {
    if (totalPages <= WINDOW || page <= 3) return 1;
    if (page >= totalPages - 2) return totalPages - WINDOW + 1;
    return page - 2;
};

// Previous / numbered pages / Next. Renders nothing when there is only one page.
function Pagination({ page, totalPages, onPageChange, className }) {
    if (!totalPages || totalPages <= 1) return null;
    const first = windowStart(page, totalPages);
    const pages = Array.from({ length: Math.min(WINDOW, totalPages) }, (_, i) => first + i);

    return (
        <nav aria-label="Pagination" className={cn('mt-6 flex flex-col items-center justify-between gap-4 sm:flex-row', className)}>
            <p className="text-sm text-slate-600 dark:text-slate-400">
                Page <span className="font-semibold text-slate-900 dark:text-white">{page}</span> of {totalPages}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-1.5">
                <Button variant="secondary" size="sm" icon={LuChevronLeft} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
                    Previous
                </Button>
                {pages.map((n) => {
                    const current = n === page;
                    return (
                        <button
                            key={n}
                            type="button"
                            aria-current={current ? 'page' : undefined}
                            onClick={() => onPageChange(n)}
                            className={cn(
                                'h-8 min-w-[2rem] rounded-lg px-2 text-sm font-medium tabular-nums transition-colors duration-300',
                                fillClass,
                                current
                                    ? 'bg-brand-600 text-white shadow-sm before:bg-brand-900 dark:before:bg-brand-500'
                                    : 'text-slate-600 before:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:before:bg-slate-800 dark:hover:text-white'
                            )}
                        >
                            {n}
                        </button>
                    );
                })}
                <Button
                    variant="secondary"
                    size="sm"
                    iconRight={LuChevronRight}
                    disabled={page >= totalPages}
                    onClick={() => onPageChange(page + 1)}
                >
                    Next
                </Button>
            </div>
        </nav>
    );
}

export default Pagination;
